import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import SwipeableDrawer from '@core/dashboard/components/SwipeableDrawer';
import {
  Header,
  ModalContainer,
  Tabs,
} from '@core/dashboard/components/PopoverModal';
import RaisedHandsContent from './RaisedHandsContent';
import { useHomeBottomBarContext } from '../providers/HomeBottomBarProvider';

const RaisedHands = ({ t: translate }: WithTranslation) => {
  const { isRaisedHandsOpen, closeRaisedHands } = useHomeBottomBarContext();

  const getHeader = () => {
    return (
      <>
        <Header
          text={translate('raisedHandsModal.title')}
          onClose={closeRaisedHands}
          isBig
        />
        <Tabs
          active={'in-session'}
          tabs={[
            {
              label: translate('raisedHandsModal.inSession'),
              value: 'in-session',
            },
          ]}
          onChange={() => {}}
        />
      </>
    );
  };

  return (
    <SwipeableDrawer
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      open={isRaisedHandsOpen}
      onClose={closeRaisedHands}
      onOpen={() => {}}
    >
      <ModalContainer isScrollable={false} header={getHeader()}>
        <RaisedHandsContent />
      </ModalContainer>
    </SwipeableDrawer>
  );
};

export default withTranslation()(RaisedHands);
